/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiLeadScoreAdjustmentReason;
(function (ApiLeadScoreAdjustmentReason) {
    ApiLeadScoreAdjustmentReason["LEAD_SCORE_ADJUSTMENT_REASON_INACTIVITY"] = "LEAD_SCORE_ADJUSTMENT_REASON_INACTIVITY";
})(ApiLeadScoreAdjustmentReason || (ApiLeadScoreAdjustmentReason = {}));
export function ApiLeadScoreAdjustmentReasonFromJSON(json) {
    return ApiLeadScoreAdjustmentReasonFromJSONTyped(json, false);
}
export function ApiLeadScoreAdjustmentReasonFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiLeadScoreAdjustmentReasonToJSON(value) {
    return value;
}
